angular.module('myApp').controller('EkspertizesVestureController', function ($scope, uuiData) {

  this.init = (ekspertize_id) => {
    uuiData.list('ekspertizes_vesture', { ekspertize_id }).$promise.then( hs => {
      $scope.history = hs
    } ).catch($scope.failing)
  }
  
})
